var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.$store.state.specialLoading)?_c('div',{staticClass:"loading"},[_c('div',{staticClass:"rocket"}),_c('h3',{staticClass:"text"},[_vm._v(" "+_vm._s(_vm.textList[_vm.currentTextIndex])+" ")])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }